import apiClient from './apiClient';

export async function listHistory() {
  const res = await apiClient.get('/reports/history');
  return res.data.data.items;
}

/** Downloads a report by triggering a real file save via an anchor element —
 * needs responseType 'blob' since these endpoints return binary files, not JSON. */
export async function downloadReport(path, filename) {
  const res = await apiClient.get(path, { responseType: 'blob' });
  const url = window.URL.createObjectURL(new Blob([res.data]));
  const link = document.createElement('a');
  link.href = url;
  link.setAttribute('download', filename);
  document.body.appendChild(link);
  link.click();
  link.remove();
  window.URL.revokeObjectURL(url);
}
